module.exports = __webpack_public_path__ + "img/img-11@2x.02b422a5.png";